import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/comics';

const footerLinks = [
  {
    title: '热门分类',
    links: categories.slice(0, 4).map((c) => ({
      label: c.name,
      href: `/category/${c.slug}`,
    })),
  },
  {
    title: '更多分类',
    links: categories.slice(4, 8).map((c) => ({
      label: c.name,
      href: `/category/${c.slug}`,
    })),
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '用户口碑', href: '/about#testimonials' },
      { label: '联系我们', href: '/about#contact' },
      { label: '常见问题', href: '/about#faq' },
    ],
  },
  {
    title: '帮助中心',
    links: [
      { label: '使用指南', href: '/about' },
      { label: '版权声明', href: '/about' },
      { label: '隐私政策', href: '/about' },
      { label: '服务条款', href: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="w-full px-4 md:px-6">
        {/* Top Nav */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 py-16">
          {footerLinks.map((col, i) => (
            <div key={i}>
              <h4 className="text-sm font-semibold text-white mb-4 tracking-wide uppercase">
                {col.title}
              </h4>
              <div className="w-6 h-px bg-background-400/30 mb-4"></div>
              <ul className="space-y-2.5">
                {col.links.map((link, j) => (
                  <li key={j}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-300 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div className="border-t border-background-800/30 py-10">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
            {/* Left */}
            <div className="flex flex-col gap-2">
              <div className="flex items-baseline gap-1">
                <span className="text-4xl font-black text-white font-heading">{siteInfo.name}</span>
              </div>
              <div className="w-8 h-0.5 bg-primary-500/60 mb-1"></div>
              <p className="text-sm text-background-400 max-w-md">
                {siteInfo.tagline} · 已收录 {siteInfo.totalComics} 部漫画 · {siteInfo.updateFrequency}
              </p>
            </div>

            {/* Right */}
            <div className="flex flex-col items-start sm:items-end gap-3">
              <div className="flex items-center gap-4">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800/40 hover:bg-background-700/40 transition-colors cursor-pointer">
                  <i className="ri-wechat-line text-background-300"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800/40 hover:bg-background-700/40 transition-colors cursor-pointer">
                  <i className="ri-weibo-line text-background-300"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800/40 hover:bg-background-700/40 transition-colors cursor-pointer">
                  <i className="ri-bilibili-line text-background-300"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800/40 hover:bg-background-700/40 transition-colors cursor-pointer">
                  <i className="ri-mail-line text-background-300"></i>
                </a>
              </div>
              <p className="text-xs text-background-500">
                &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 · 本站所有漫画资源均来自网络，仅供学习交流使用
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}